import TrackedModel from "../models/tracked/trackedModel";

export default {
  methods: {
    paste(text: string, input: HTMLInputElement | HTMLTextAreaElement, model: TrackedModel, property: string): void {
      const selection = window.getSelection();
      const label = model[property] || '';
      const selectionStart = input.selectionStart;
      const selectionEnd = input.selectionEnd;
      const newCursorPosition = text.length + selectionEnd;
      if (selection.rangeCount) {
        model[property] = label.slice(0, selectionStart) + text + label.slice(selectionEnd);
      } else {
        model[property] = text;
      }
      this.$nextTick(() => input.setSelectionRange(newCursorPosition, newCursorPosition));
    },
  }
};
